module.exports = __webpack_public_path__ + "img/Application-Scenarios-4.27556b3.jpg";